import { MatDateFormats } from '@angular/material/core';

export interface AvailableReport {
  name: string;
  endpoint: string;
  startDt?: boolean;
  endDt?: boolean;
  downloadFormat?: 'csv' | 'pdf';
  dateRangeType?: 'year' | 'date';
}

export interface Report {
  type: string;
  availableReports: AvailableReport[];
}

export interface ReportDownloadDialogData {
  report: AvailableReport;
  minDate: Date;
  maxDate: Date;
  minYearDate: Date;
  maxYearDate: Date;
}

export const DATE_FORMAT = 'YYYY-MM-DD';
export const YEAR_FORMAT = 'YYYY';

export const YEAR_MODE_FORMATS: MatDateFormats = {
  parse: { dateInput: 'YYYY' },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

export const DATE_MODE_FORMATS: MatDateFormats = {
  parse: { dateInput: 'MM/DD/YYYY' },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

// The backend sends startDt/endDt as boolean or the string "true".
export function isFlagOn(flag: unknown): boolean {
  return flag === true || flag === 'true';
}
